import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { UAVStatus } from '../../model/UAVStatus';
import { UrlConfig } from '../../model/urlconfig';
import { HttpOptions, UpdateActionType } from '../../service/generic-akita-http.service';
import { WebsocketService } from '../../service/websocket.service';
import { UAVsState, UAVsStore } from '../state/uavs.store';
import { AkitaUAVHttpService } from './akita-http-uav.service.';


@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class UAVsService extends NgEntityService<UAVsState> implements UrlConfig {

  constructor(
    protected store: UAVsStore,
    private uavHttpService: AkitaUAVHttpService,
    private webSocketService: WebsocketService,
  ) {
    super(store);

    this.webSocketService.getDataStream('UAVStatus')
      .pipe(untilDestroyed(this))
      .subscribe((data: UAVStatus[]) => this.store.upsertMany(data));
  }
  updateEntitiesUrl(newUrl: string): void {
    this.uavHttpService.setEntitiesUrl(newUrl);
  }

  getAll() {
    this.uavHttpService.getAll().subscribe(uavs => this.store.set(uavs));
  }

  getById(id: ID) {
    this.uavHttpService.loadById(id).subscribe(uavs => this.store.add(uavs));
  }

  nameUav(uav: UAVStatus, name: string) {
    this.store.update(uav.id, { name });

    const options: HttpOptions = {
      params: {
        options: 'keyValues'
      }
    };
    this.uavHttpService.update({ ...uav, name }, UpdateActionType.APPEND, options)
      .subscribe(
        data => console.log('Updated UAV', data),
        error => console.log('Error inserting in Hub', error)
      );
  }

}
